import { createInjectionStateOrThrow } from '@abaninja/utils';

import { useAppNavigationIcon } from './AppNavigationIcon.use';

export const [provideAppNavigationIcon,
  injectAppNavigationIconOrThrow] = createInjectionStateOrThrow('AppNavigationIcon', useAppNavigationIcon);
